import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail, LOGO_URL } from "../../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.email) return <Navigate to="/portal/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bem-vindo de volta.");
      navigate("/portal/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Falha no login.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-peca-black border-2 border-peca-line focus:border-peca-yellow outline-none px-4 py-4 text-peca-cream placeholder:text-peca-grey/60 transition-colors duration-200";

  return (
    <div className="min-h-screen flex items-center justify-center bg-peca-black px-5">
      <div className="w-full max-w-md">
        <img src={LOGO_URL} alt="Peça Business Solutions" className="h-12 w-auto mb-10" />
        <div className="flex items-center gap-3 mb-8">
          <Lock className="text-peca-yellow" size={20} />
          <span className="label-mono text-peca-grey">Portal Peça — Acesso restrito</span>
        </div>
        <h1 className="font-display font-extrabold uppercase text-4xl tracking-tight text-peca-cream mb-10">
          Entrar
        </h1>
        <form onSubmit={submit} data-testid="admin-login-form" className="flex flex-col gap-5">
          <input data-testid="admin-email" type="email" className={inputCls} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="admin-password" type="password" className={inputCls} placeholder="Palavra-passe" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="mt-2 inline-flex items-center justify-center gap-2 bg-peca-yellow text-peca-black font-display font-bold uppercase text-sm tracking-wide px-8 py-4 hover:bg-peca-cream transition-colors duration-200 disabled:opacity-60"
          >
            {loading && <Loader2 size={18} className="animate-spin" />}
            {loading ? "A entrar…" : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
